<template>
  <div class="p-device">
    <gheader ref="gheader"></gheader>
    <div class="p-device-back"></div>
    <div class="p-device-select" v-if="showSelect">
      <div class="p-device-select-back"></div>
      <div class="p-device-select-con">
        <a-drawer :closable="false" :placement="placement" :visible="showSelect" title="请选择您的课程">
          <div class="p-device-select-container">
            <div :key="index" class="p-device-select-item" v-for="(user, index) in users">
              <p class="p-device-select-item-name">我是{{ user.name }}</p>
              <p class="p-device-select-item-number">学号：{{ user.student_number }}</p>
              <div
                class="p-device-select-item-bottom"
                v-if="user.is_open == 2 || user.online_is_open == 2"
              >
                <button
                  @click="onSelect($event, user, 1)"
                  class="p-device-select-item-btn"
                  v-if="user.is_open == 2"
                >开始线下课</button>
                <button
                  @click="onSelect($event, user, 2)"
                  class="p-device-select-item-btn"
                  v-if="user.online_is_open == 2"
                >开始线上课</button>
              </div>
              <div class="p-device-select-item-bottom" v-else>
                <p class="p-device-select-item-bottom-tip">暂无课程</p>
              </div>
            </div>
          </div>
        </a-drawer>
      </div>
    </div>
    <div class="p-device-container">
      <p class="p-device-title" v-if="student">
        <span>{{ student.name }}</span>
        <span class="p-device-title-date">今日课程 {{ todayDate }}</span>
      </p>
      <div class="p-device-view">
        <p class="p-device-view-tip">{{ errorTip }}</p>
        <div
          :style="
            panelType == 2 ? '' : 'opacity: 0;position: absolute;z-index:2'
          "
          class="p-device-view-play"
        >
          <div class="p-device-tabs-con">
            <div class="g-live-container">
              <div id="g-live-con"></div>
              <div class="g-live-start">
                <div class="g-live-start-logo"></div>
              </div>
            </div>
            <glive @error="onError" ref="glive"></glive>
          </div>
        </div>
      </div>
      <div class="p-device-line-1">
        <div
          class="p-device-tabs"
          v-if="
            currentLesson &&
            currentLesson.device_sn &&
            currentLesson.device_sn.length > 0
          "
        >
          <a-radio-group :default-value="0" @change="snChange" button-style="solid" size="small">
            <a-radio-button
              :key="index"
              :value="index"
              v-for="(item, index) in currentLesson.device_sn"
            >{{ item.display_name || item.url }}</a-radio-button>
          </a-radio-group>
        </div>
        <p class="p-device-lesson-title" v-if="lessons">今日课程表</p>
        <a-button @click="onShowLesson" class="p-device-lesson-btn" v-if="lessons">今日课程表</a-button>
      </div>
      <div class="p-device-lesson">
        <div
          :class="'p-device-lesson-item ' + getStatusStyle(ls)"
          :key="index"
          v-for="(ls, index) in lessons"
        >
          <div class="p-device-lesson-item-con">
            <div class="p-device-lesson-line-1">
              <p class="p-device-lesson-p1">{{ "第" + (index + 1) + "节：" + ls.time_interval }}</p>
              <a-button
                :style="
                  'background: 0; border: 0; opacity: 0.6;color: ' +
                  getStatusColor(ls)
                "
                @click="
                  (e) => {
                    onCheckDesc(ls);
                  }
                "
                class="p-device-lesson-p2"
                icon="question-circle"
              />
            </div>
            <p class="p-device-lesson-p3">{{ getStatusTx(ls) }}</p>
            <p class="p-device-lesson-p4">{{ ls.name + " " + ls.teacher_name + " " + ls.weight }}</p>
          </div>
        </div>
      </div>
    </div>
    <a-drawer
      :closable="false"
      :placement="placement2"
      :visible="showLessonPanel"
      @close="onClose"
      class="p-device-lesson-alert"
      title="今日课程表"
    >
      <div
        :class="'p-device-lesson-item ' + getStatusStyle(ls)"
        :key="index"
        v-for="(ls, index) in lessons"
      >
        <div class="p-device-lesson-item-con">
          <div class="p-device-lesson-line-1">
            <p class="p-device-lesson-p1">{{ "第" + (index + 1) + "节：" + ls.time_interval }}</p>
            <a-button
              :style="
                'background: 0; border: 0; opacity: 0.6;color: ' +
                getStatusColor(ls)
              "
              @click="
                (e) => {
                  onCheckDesc(ls);
                }
              "
              class="p-device-lesson-p2"
              icon="question-circle"
            />
          </div>
          <p class="p-device-lesson-p3">{{ getStatusTx(ls) }}</p>
          <p class="p-device-lesson-p4">{{ ls.name + " " + ls.teacher_name + " " + ls.weight }}</p>
        </div>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import global from "../../utils/Global";
import glive from "../device/live";
import gheader from "../main/header";

var lessTimer = 0;

export default {
  data () {
    return {
      currentLesson: null,
      showDesc: false,
      showSelect: false,
      placement: "bottom",
      placement2: "right",
      showLessonPanel: false,
      users: [],
      screen: null,
      student: null,
      todayDate: null,
      today: "",
      isSafari: false,
      panelType: 1,
      errorTip: null,
      lessons: null,
      currentSnIndex: 0,
      type: null,
    };
  },
  mounted () {
    if (!global.userInfo) {
      this.$router.push("login");
      return;
    }
    var ua = navigator.userAgent;
    var mobile = !!ua.match(/AppleWebKit.*Mobile.*/);
    if (!mobile) {
      this.$router.push("device");
      return;
    }
    this.getStudentId();
  },
  methods: {
    onClose () {
      this.showLessonPanel = false;
    },
    onCheckDesc (item) {
      console.log(item);
      const h = this.$createElement;
      this.$info({
        title: "课时信息",
        content: h("div", {}, [
          h("p", "课时名称："),
          h("p", item.name),
          h("p", "所属课程："),
          h("p", item.course_name),
          h("p", "优先级："),
          h("p", item.weight),
        ]),
        onOk () { },
      });
    },
    onresizeHander () {
      var w = $(window).width();
      var h = $(window).height();

      $(".p-device-view").css({
        width: w + "px",
        height: w * 0.5625 + "px",
        top: "64px",
        left: 0,
        "margin-left": 0,
      });
      $(".p-device-view-play").css({
        width: w + "px",
        height: w * 0.5625 + "px",
      });
      $(".ant-drawer-content-wrapper").css({
        height: h * 0.67 + "px",
      });
      if (this.screen == "vertical") {
        var viewtop = 95;
        if (
          $(".p-device-view") &&
          $(".p-device-view").offset() &&
          $(".p-device-view").offset().top
        ) {
          viewtop = $(".p-device-view").offset().top;
        }
        var wt = viewtop + $(".p-device-view").height() - 20;
        $(".p-device-line-1").css({ top: wt + "px", "z-index": 2 });
        var st = wt + $(".p-device-line-1").height() + 10;
        var wh = h - st - 40;
        $(".p-device-lesson").css({
          width: w + "px",
          height: wh + "px",
          top: st + "px",
        });
      } else {
        var per = w / h;
        if (per >= 1.53) {
          //手机横屏
          var mh = h - 30;
          var mw = mh / 0.5625;
          $(".p-device-view").css({
            width: mw + "px",
            height: mh + "px",
            top: "0px",
            left: "50%",
            "margin-left": -mw / 2 + "px",
          });
          $(".p-device-view-play").css({
            width: mw + "px",
            height: mh + "px",
          });
        } else {
          //pad横屏
        }
        $(".p-device-line-1").css({ top: "24px", "z-index": "7" });
        $(".p-device-lesson-alert .ant-drawer-content-wrapper").css({
          width: "400px",
          height: "100%",
        });
      }
      var tt = $(".p-device-view").height() * 0.75;
      $(".p-device-view-tip").css({ top: tt + "px" });
    },
    onShowLesson () {
      this.showLessonPanel = true;
      this.$nextTick(() => {
        this.onresizeHander();
        $(".ant-drawer-content").css({
          background:
            "#303030 url(https://p4.ssl.qhimg.com/t01ae1148cfc4c15adc.jpg) no-repeat center",
          "background-size": "auto 100%",
        });
      });
    },
    onError (e) {
      if (e) {
        this.showTipMsg("请升级浏览器，建议使用新版本Chrome浏览器。");
      } else {
        this.showTipMsg("播放异常，请检查摄像头状态");
      }
    },
    showTipMsg (msg) {
      this.lessons = [];
      this.showError(msg);
      this.$alert(msg);
    },
    snChange (e) {
      this.currentSnIndex = e.target.value;
      this.openStreamAndPlay();
    },
    openStreamAndPlay () {
      if (this.$refs.glive) {
        this.$refs.glive.stop();
      }
      var item = this.currentLesson.device_sn[this.currentSnIndex];
      this.axios(global.ajaxAdd.devicePlayNew, {
        device_sn: item.url,
        student_id: this.student_id,
        id: this.currentLesson.id,
      })
        .then((d) => {
          this.hasShowError = false;
          this.isPlaying = true;
          this.panelType = 2;
          $(".p-device-tabs").show();
          this.$nextTick(() => {
            if (this.$refs.glive) {
              this.$refs.glive.initPlayer();
              if (d.data.flashUrl.indexOf("http://") != -1) {
                d.data.flashUrl = d.data.flashUrl.replace(
                  "http://",
                  "https://"
                );
              }
              this.$refs.glive.live(d.data.flashUrl, d.data.playKey);
              this.$refs.glive.resize(this.playW, this.playH);
              this.$nextTick(() => {
                setTimeout(() => { }, 1000);
              });
            }
          });
        })
        .catch((e) => {
          this.isPlaying = false;
          if (this.$refs.glive) {
            this.$refs.glive.stop();
          }
          if (!this.hasShowError) {
            this.hasShowError = true;
            this.errorTip = e.data.errmsg;
            this.msg(e.data.errmsg, "error");
          }
        });
    },
    onSelect (e, user, type) {
      $(".g-select-item").each(function () {
        $(this).css({ border: "4px solid #fff" });
        var id_ = $(this).data().id;
        if (user.id == id_) {
          $(this).css({ border: "4px solid #0495fc" });
        }
      });
      $(".g-select-btn").each(function () {
        $(this).css({ background: "#fff", color: "#333" });
      });
      var tar = e.currentTarget;
      tar.style.background = "#0495fc";
      tar.style.color = "#fff";

      this.showLessons(user, type);
      this.showSelect = false;
    },
    showLessons (user, type) {
      this.student = user;
      this.student_id = user.id;
      this.type = type;
      var that = this;
      this.axios(global.ajaxAdd.getList, {
        student_id: user.id,
        course_type: type,
      })
        .then((d) => {
          var n = Math.floor(new Date().getTime() / 1000);
          that.timeDiff = d.data.time - n;
          that.setToday();
          var l = d.data.list;

          //创建一条假数据，用于测试
          //   l.push({
          //     id: 100002,
          //     name: "测试weight3",
          //     course_name: "测试weight3",
          //     device_sn: [
          //       {
          //         type: "device",
          //         url: "360210700065245",
          //         display_name: "化学实验室3",
          //       },
          //     ],
          //     time_interval: "13:08--14:59",
          //     teacher_name: "测试",
          //     weight: 7,
          //   });
          var arr = [];
          for (var i in l) {
            l[i].device_list = [];
            for (var k = 0; k < l[i].device_sn.length; k++) {
              var u = l[i].device_sn[k].url;
              var n = l[i].device_sn[k].display_name
                ? "【" + l[i].device_sn[k].display_name + "】"
                : "";
              l[i].device_list.push(u + n);
            }
            var t = l[i].time_interval;
            var ts = t.split("--");
            if (ts.length > 1) {
              l[i].les_start = ts[0];
              l[i].les_end = ts[1];
              l[i].les_start_ms = new Date(
                that.today + ts[0] + ":00"
              ).getTime();
              l[i].les_end_ms = new Date(that.today + ts[1] + ":00").getTime();
            }
            arr.push(l[i]);
          }
          if (arr.length == 0) {
            var msg_ = "暂无课程或未开启课程权限，请联系管理员";
            that.showError(msg_);
          }
          that.lessons = arr;
          var isNotEnd = false;
          var less = null;
          for (var i = 0; i < arr.length; i++) {
            if (
              arr[i].course_session_status == 6 ||
              arr[i].course_session_status == 5
            ) {
              isNotEnd = true;
            }
            if (arr[i].course_session_status == 6) {
              less = arr[i];
            }
          }
          if (isNotEnd == false) {
            clearInterval(lessTimer);
            lessTimer = 0;
            if (that.$refs.glive) {
              that.$refs.glive.stop(true);
            }
            that.currentSnIndex = 0;
            that.panelType = 1;
            that.currentLesson = null;
            that.isPlaying = false;
            that.errorTip = "课程已全部结束，请联系管理员";
            console.log("课程已结束");
            return;
          }
          if (!lessTimer) {
            console.log("定时器开启");
            lessTimer = setInterval(function () {
              that.showLessons(that.student, that.type);
            }, 10000);
          }
          if (!less) {
            if (that.$refs.glive) {
              that.$refs.glive.stop(true);
            }
            that.currentSnIndex = 0;
            that.panelType = 1;
            that.currentLesson = null;
            that.isPlaying = false;
            that.errorTip = "目前没有可上的课程，请联系管理员";
            console.log("目前没有可上的课程");
          } else {
            if (
              !that.currentLesson ||
              less.id != that.currentLesson.id ||
              !that.isPlaying
            ) {
              //没有开播、课时id变更、设备sn列表变更，
              this.onlyChangeLesson(less);
              this.openStreamAndPlay();
            } else if (that.currentLesson) {
              var changePlaying = false;
              for (var g = 0; g < that.currentLesson.device_sn.length; g++) {
                //当前正在播放的sn
                if (
                  g == that.currentSnIndex &&
                  less.device_sn[g].url != that.currentLesson.device_sn[g].url
                ) {
                  changePlaying = true;
                  break;
                }
              }
              this.onlyChangeLesson(less);
              if (changePlaying) {
                this.openStreamAndPlay();
              }
            }
          }
        })
        .catch((e) => {
          console.warn("error", e);
          that.errorTip = e.data.errmsg;
          that.msg(e.data.errmsg, "error");
        });
      this.$nextTick(() => {
        $(".p-device-step-a").off("click");
        $(".p-device-step-a").click(() => {
          this.stepShow = !this.stepShow;
          this.changePlaySize();
        });
      });
    },
    getStudentId () {
      this.axios(global.ajaxAdd.checkUser, {})
        .then((d) => {
          //从服务器获取用户角色
          if (!d || !d.data || d.data.length == 0) {
            this.showTipMsg("暂无课程或未开启课程权限，请联系管理员");
            return;
          }
          if (d.data.length > 1) {
            this.users = d.data;
            this.showSelect = true;
          } else {
            var stu = d.data[0];
            //学生的线上课和线下课都开着
            if (stu.is_open == 2 && stu.online_is_open == 2) {
              this.users = d.data;
              this.showSelect = true;
            } else if (stu.is_open != 2 && stu.online_is_open != 2) {
              this.showTipMsg("暂无课程或未开启课程权限，请联系管理员");
              return;
            } else {
              this.type = stu.is_open == 2 ? 1 : 2;
              this.student = stu;
              this.student_id = stu.id;
              this.userName = stu.name;
              this.showLessons(stu, this.type);
            }
          }
          this.$nextTick(() => {
            var that = this;
            that.onresizeHander();
            window.onresize = function () {
              that.onresizeHander();
            };
            setInterval(() => {
              if ($("body").hasClass("horizontal-screen")) {
                if (this.screen != "horizontal") {
                  this.screen = "horizontal";

                  that.onresizeHander();
                }
              } else {
                if (this.screen != "vertical") {
                  this.screen = "vertical";
                  that.onresizeHander();
                }
              }
            });
          }, 300);
        })
        .catch((e) => {
          this.msg(e.data.errmsg, "error");
          this.$alert(e.data.errmsg);
          this.showError(e.data.errmsg);
        });
    },
    showError (errmsg) {
      this.errorTip = errmsg;
      this.panelType = 3;
    },
    onlyChangeLesson (less) {
      this.currentSnIndex = 0;
      this.currentLesson = less;
      if (this.screen == "horizontal") {
        $(".ant-radio-button-wrapper").css({ "max-width": "150px" });
      } else {
        if (this.currentLesson.device_sn.length <= 2) {
          $(".ant-radio-button-wrapper").css({ "max-width": "100px" });
        } else {
          $(".ant-radio-button-wrapper").css({ "max-width": "80px" });
        }
      }
    },
    getStatusTx (item) {
      if (item.course_session_status == 6) {
        return "正上课";
      }
      if (item.course_session_status == 7) {
        return "已下课";
      } else {
        return "待上课";
      }
    },
    getStatusStyle (item) {
      if (item.course_session_status == 6) {
        return "status-2";
      }
      if (item.course_session_status == 7) {
        return "status-1";
      } else {
        return "status-3";
      }
    },
    getStatusColor (item) {
      if (item.course_session_status == 6) {
        return "#006bff";
      }
      if (item.course_session_status == 7) {
        return "#cccccc";
      } else {
        return "#737373";
      }
    },

    axios (url, data) {
      var pubData_ = {
        from: "student",
        qid: global.userInfo.qid,
        reg_time: new Date().getTime(),
      };
      if (this.student_id) {
        pubData_.student_id = this.student_id;
      }
      data = Object.assign(pubData_, data);
      var that = this;

      return new Promise(function (resolve, reject) {
        that.$axios
          .post("/api" + url, data, {
            transformRequest: [
              function (data) {
                let params = "";
                for (let index in data) {
                  params += index + "=" + data[index] + "&";
                }
                return params;
              },
            ],
          })
          .then(function (res) {
            if (res && res.data && res.data.errno == 0) {
              if (resolve) {
                resolve(res.data);
              }
            } else {
              reject(res);
              //   that.errorTip = res.data.errmsg;
              //   that.msg(res.data.errmsg, "error");

              switch (res.data.errno) {
                case 400027:
                  break;
                case 442:
                  //登录信息过期
                  clearTimeout(lessTimer);
                  that.$router.push("login");
                  break;
                case 1000001:
                  that.lessons = [];

                  break;
              }
            }
          })
          .catch(function (e) {
            reject(e);
            // that.msg(e.errmsg, "error");
            that.$alert(e.data.errmsg);
          });
      });
    },
    msg (text, type) {
      this.$msg.destroy();
      if (type == "success") {
        this.$msg.success(text);
      } else if (type == "error") {
        this.$msg.error(text);
      } else if (type == "info") {
        this.$msg.info(text);
      }
    },
    setToday () {
      var dt = new Date(new Date().getTime() + this.timeDiff);
      var dy = dt.getFullYear();
      var dm = dt.getMonth() + 1;
      var dd = dt.getDate();
      this.todayDate = dy + "年" + dm + "月" + dd + "日";
      var ua = navigator.userAgent.toLowerCase();
      this.isSafari = ua.match(/version\/([\d.]+).*safari/);
      if (this.isSafari) {
        this.today = dy + "/" + dm + "/" + dd + " ";
      } else {
        this.today = dy + "-" + dm + "-" + dd + " ";
      }
    },
  },
  components: {
    gheader,
    glive,
  },
};
</script>

<style scoped>
.ant-radio-button-wrapper {
  max-width: 110px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-radio-button-wrapper {
  background: 0;
  color: #fff;
}
.ant-radio-group-solid
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  background: rgba(64, 169, 255, 0.6);
  color: #fff;
}
.p-device-lesson-item {
  width: 90%;
  height: 70px;
  position: relative;
  margin: 20px auto 0;
  border-bottom: 1px solid #5d5e5e;
}

.p-device-lesson-p1 {
  font-size: 16px;
  line-height: 32px;
  height: 32px;
}
.p-device-lesson-p3 {
  padding: 4px 6px;
  font-size: 12px;
  position: absolute;
  top: 6px;
  right: 16px;
  opacity: 0.8;
}
.p-device-lesson-item-con {
  position: relative;
}
.status-1 .p-device-lesson-p3 {
  height: 22px;
  line-height: 16px;
  padding: 2px 4px;
  color: #c4a7e1;
  border: 1px solid #c4a7e1;
  border-radius: 3px;
}
.status-2 .p-device-lesson-p3 {
  height: 22px;
  line-height: 20px;
  padding: 0 4px;
  color: #006bff;
  border: 1px solid #006bff;
  border-radius: 3px;
}
.status-3 .p-device-lesson-p3 {
  height: 22px;
  line-height: 20px;
  padding: 0 4px;
  color: #838383;
  border: 1px solid #838383;
  border-radius: 3px;
}
.p-device-lesson-p4 {
  font-size: 14px;
  position: absolute;
  top: 36px;
  left: 0;
  opacity: 0.8;
}
.g-live {
  width: 0;
  height: 0;
}
.g-live-container {
  width: 100%;
  height: 100%;
  position: relative;
}
.status-1 p {
  color: #cccccc;
}
.status-2 p {
  color: #006bff;
}
.status-3 p {
  color: #737373;
}
.p-device-line-1 {
  width: 100%;
  height: 30px;
  position: absolute;
  z-index: 0;
  display: flex;
}
.p-device-lesson-line-1 {
  width: 100%;
  height: 34px;
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  display: flex;
}
.p-device-tabs {
  position: absolute;
  right: 20px;
  top: 0;
}
.horizontal-screen .p-device-tabs {
  right: 124px;
}
.p-device-lesson-title {
  height: 24px;
  line-height: 24px;
  margin-left: 20px;
  color: #fff;
  font-size: 20px;
}
.p-device-lesson-btn {
  height: 24px;
  padding: 0 7px;
  line-height: 22px;
  background: 0;
  color: #fff;
  position: absolute;
  top: 0;
  right: 20px;
  display: none;
}
.horizontal-screen .p-device-lesson-btn {
  display: block;
}
.horizontal-screen .p-device-lesson-title {
  display: none;
}
.p-device-lesson {
  width: 100%;
  position: absolute;
  top: 296px;
  left: 0;
  /* border: 1px solid #fff; */
  overflow: auto;
}
.horizontal-screen .p-device-lesson {
  display: none;
}

.p-device-view-tip {
  width: 100%;
  font-size: 14px;
  color: #a5a6a6;
  text-align: center;
  bottom: 20px;
  position: absolute;
  left: 0;
}
.p-device-view {
  width: 100%;
  position: absolute;
  background: #212427 url(https://p5.ssl.qhimg.com/t01922bca5389109b81.jpg)
    center no-repeat;
  background-size: 226px 168px;
  z-index: 2;
  top: 64px;
  left: 0;
}
.p-device-view-play {
  width: 100%;
  position: absolute;
  z-index: 5;
  top: 0;
  left: 0;
}
.p-device-tabs-con {
  width: 100%;
  height: 100%;
  position: relative;
}

.p-device-title {
  font-size: 18px;
  font-weight: bolder;
  padding: 20px 0 0 10px;
  line-height: 24px;
  color: #fff;
  position: relative;
  z-index: 6;
}
.p-device-title-date {
  font-size: 14px;
}
.p-device-select-item-btn {
  justify-content: flex-end;
  margin-left: 0.1rem;
  font-size: 16px;
  background: #fff;
  color: #333;
  border: 0.01rem solid #333;
  border-radius: 0.04rem;
}
.p-device-select-item-name {
  width: 100%;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 0.1rem;
}
.p-device-select-item-number {
  font-size: 14px;
}
.p-device-select-item-bottom {
  position: absolute;
  bottom: 0.12rem;
  right: 0;
  display: flex;
}
.p-device-select-item {
  width: 100%;
  height: 70px;
  position: relative;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 0.2rem;
}
.p-device {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: #303030;
}
.p-device-back {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1;
  opacity: 0.2;
  background: #303030 url(https://p4.ssl.qhimg.com/t01ae1148cfc4c15adc.jpg)
    no-repeat center;
  background-size: auto 100%;
}
.p-device-select {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
}

.p-device-select-back {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
}
.p-device-container {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
}
</style>


// WEBPACK FOOTER //
// src/components/page/h5/mdevice.vue